


























































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Barcode from "../../components/bar-code.vue";
import { mixins } from "vue-class-component";
import _ from "lodash";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import SerialListModal from "../../components/view-serials-paging.vue";
import SerialInfo from "@/store/entities/products/serial-info";

class PageReturnOrderReceiptLineRequest extends PageRequest {
  keyword: string;
  id: number;
}

@Component({
  components: {
    "bar-code": Barcode,
    "serial-modal": SerialListModal,
  },
})
export default class ViewReturnOrderReceipt extends mixins(
  DateTimeMixin,
  AbpBase
) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  namespace = "returnOrderReceipt";
  linePageRequest: PageReturnOrderReceiptLineRequest =
    new PageReturnOrderReceiptLineRequest();
  returnOrderReceipt: any;
  serialModalShow: boolean = false;
  serialInfo = new SerialInfo();

  spinShow: boolean = false;
  code: string = "";
  id: number = 0;
  creationTime: Date[] = [];

  get store() {
    return this.$store.state.returnOrderReceipt;
  }
  get returnOrderReceiptCode() {
    return this.code;
  }

  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  openSerialModal() {
    this.serialModalShow = true;
  }
  closeSerialModal() {
    this.serialModalShow = false;
    this.serialInfo = new SerialInfo();
  }
  showDetail(row) {
    this.serialInfo.productName = row.productName;
    this.serialInfo.productId = row.productId;
    this.serialInfo.qty = row.receivedQty;
    this.serialInfo.serials = _.map(row.serials, function (item) {
      var serial = {
        serialNo: item,
      };
      return serial;
    });
    this.openSerialModal();
  }

  //============line page =================
  get sumReceivedQty() {
    return _.isNil(this.lineList) || this.lineList.length <= 0
      ? 0
      : this.lineList[0].sumReceivedQty;
  }

  get lineLoading() {
    return this.store.lineLoading;
  }
  get linePageSize() {
    return this.store.linePageSize;
  }
  get lineTotalCount() {
    return this.store.lineTotalCount;
  }
  get lineCurrentPage() {
    return this.store.lineCurrentPage;
  }
  refreshLinePageIndex() {
    this.$store.commit(`${this.namespace}/setLineCurrentPage`, 1);
  }
  linePageChange(page: number) {
    this.$store.commit(`${this.namespace}/setLineCurrentPage`, page);
    this.getLinePage();
  }
  linePageSizeChange(pagesize: number) {
    this.$store.commit(`${this.namespace}/setLinePageSize`, pagesize);
    this.getLinePage();
  }
  async searchLineData() {
    this.refreshLinePageIndex();
    await this.getLinePage();
  }
  preGetLinePage() {
    this.linePageRequest.id = this.id;
    this.linePageRequest.maxResultCount = this.linePageSize;
    this.linePageRequest.skipCount =
      (this.lineCurrentPage - 1) * this.linePageSize;
  }
  async getLinePage() {
    this.preGetLinePage();
    await this.$store
      .dispatch({
        type: `${this.namespace}/getAllLines`,
        data: this.linePageRequest,
      })
      .catch(() => {
        this.store.lineLoading = false;
      });
  }
  get lineList() {
    var re = this.store.lineList;
    var startIndex = (this.lineCurrentPage - 1) * this.linePageSize;
    var index = 0;
    re.forEach(function (item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }

  //======== functions ===========
  cancel() {
    this.$emit("input", false);
    this.$root.$router.push({ name: "returnOrder-receipt" });
  }
  async getreturnOrderReceipt() {
    await this.$store
      .dispatch({
        type: "returnOrderReceipt/get",
        data: { id: this.id },
      })
      .then(async (result) => {
        this.returnOrderReceipt = result;
        this.id = this.returnOrderReceipt.id;
        this.code = this.returnOrderReceipt.code;
        this.getLinePage();
      });
  }

  async created() {
    this.spinShow = true;
    try {
      this.id = +this.$root.$router.currentRoute.params.id;
      await this.getreturnOrderReceipt();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
  renderWarehouseColumn() {
    if (this.isTenant()) {
      return [];
    }
    return [
      {
        title: Util.L("Warehouse"),
        width: 170,
        key: "warehouseCode",
        render: (h: any, params: any) => {
          return h(
            "span",
            `${params.row.warehouseCode} - ${params.row.warehouseName}`
          );
        },
      },
    ];
  }
  get lineColumns() {
    return [
      {
        title: Util.L("Order"),
        key: "orderNo",
        width: 50,
      },
      ...this.renderWarehouseColumn(),
      {
        title: Util.L("Sku"),
        width: 200,
        key: "sku",
      },
      {
        title: Util.L("ProductName"),
        width: 250,
        key: "productName",
      },
      {
        title: Util.L("ExportBrandName"),
        width: 200,
        key: "exportBrandName",
      },
      {
        title: Util.L("Unit"),
        width: 120,
        key: "unitName",
      },
      {
        title: Util.L("ReturnOrderCode"),
        width: 150,
        key: "returnOrderCode",
      },

      {
        title: Util.L("OrderType"),
        width: 150,
        key: "orderTypeName",
      },

      {
        title: `${Util.L("ReceivedQty")} (${this.sumReceivedQty})`,
        slot: "receivedQty",
        align: "right",
        width: 120,
      },
    ];
  }
}
